module.exports = __webpack_public_path__ + "static/praneesha-574e7a3456d10f746f86109f76c06364.png";